import React, { createContext, useContext, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { fetchJobTableAndFilterSchema } from "model/JobModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const JobContext = createContext();

export const JobProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [jobContextData, setJobContextData] = useState();

  const fetchJobContextData = async () => {
    setLoading(true);
    try {
      const response = await fetchMetadataSchema("metadata:job", () =>
        fetchJobTableAndFilterSchema([])
      );
      if (response?.success) {
        setJobContextData(response?.data);
      }
    } catch (err) {
      setError(err);
      toast.error(err?.message || "Failed to load job metadata");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAll = async () => {
      await Promise.all([]);
    };
    fetchAll();
  }, []);

  return (
    <JobContext.Provider value={{ fetchJobContextData, jobContextData, loading, error }}>
      {children}
    </JobContext.Provider>
  );
};

export const useJobContext = () => useContext(JobContext);
